import {
  Box,
  Checkbox,
  MenuItem,
  Typography,
  CircularProgress,
  FormControl,
  Select,
  OutlinedInput,
  InputLabel,
} from "@mui/material";
import AppButton from "../../../../base/AppButton.component";
import DocumentDialog from "./Document.dialog";
import { formatDate, TYPE } from "../../../../../utils/Utils";
import { useAuth } from "../../../../../context/Auth.context";
import { useEffect, useRef, useState } from "react";
import HocPopup from "../../../../../hoc/hocPopup";
import JSZip from "jszip";
import { useReactToPrint } from "react-to-print";
import { QRPageStyle } from "../../../../../utils/Styles.utils";
import { FETCH_DOCUMENT } from "../../../../../graphql/query/query";
import { useQuery } from "@apollo/client";

const DocumentsDialog = ({ customer, dialog, user, userId }) => {
  const [allChecked, setAllChecked] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [documentsList, setDocumentsList] = useState([]);

  const [response, setResponse] = useState(null);

  const [loading, setLoading] = useState(false);

  const {
    data,
    loading: documentsLoading,
    error,
  } = useQuery(FETCH_DOCUMENT, {
    variables: {
      documentInput: {
        user_id: userId,
      },
    },
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
  });
  console.log("datassss", data, customer?.insuranceList);

  const handleIndividualChange = (document) => {
    setCheckedItems((prevState) => ({
      ...prevState,
      [document.document_url]: !prevState[document.document_url],
    }));
  };

  const handlePrintAllChange = (item) => {
    setAllChecked(!allChecked);
    const newCheckedItems = {};

    if (!allChecked) {
      // for (const item of data?.fetchDocument.payload) {
      response.documents.forEach((document) => {
        newCheckedItems[document.document_url] = true;
      });
      // }
    }

    setCheckedItems(newCheckedItems);
  };

  useEffect(() => {
    const selected = Object.keys(checkedItems)
      .filter((key) => checkedItems[key])
      .map((url) => {
        for (const item of data?.fetchDocument.payload) {
          const document = item.documents.find(
            (doc) => doc.document_url === url
          );
          if (document) {
            return {
              document_name: document.document_name,
              document_url: url,
              created_at: formatDate(item?.created_at),
            };
          }
        }
        return null;
      })
      .filter(Boolean);

    setSelectedItems(selected);
  }, [checkedItems, data?.fetchDocument.payload]);
  useEffect(() => {
    if (data?.fetchDocument?.payload?.length > 0) {
      const updatedDocuments = data.fetchDocument.payload.map((item) => {
        let hasLoadFile = item?.documents.some(
          (doc) => doc.document_name === "INSURANCE LOAD SHEET"
        );

        if (!hasLoadFile) {
          return {
            ...item,
            documents: [
              ...item.documents,
              {
                document_name:
                  "Load sheet is loading. Please try after some time.",
                document_url: null,
              },
            ],
          };
        }
        return item;
      });

      setDocumentsList(updatedDocuments);
    }
  }, [data]);

  useEffect(() => {
    if (documentsList.length > 0) {
      setResponse(documentsList[0]);
    }
  }, [documentsList]);

  const handlePrint = async () => {
    setLoading(true);
    const zip = new JSZip();
    const nameCount = {};
    let count = 0;

    for (const item of selectedItems) {
      let response = await fetch(item.document_url);
      const blob = await response.blob();

      let createdAt = new Date(item.created_at);
      let formattedDate = createdAt.toISOString().split("T")[0];

      let documentName = `${item.document_name}_${formattedDate}`;
      let uniqueDocumentName = documentName;
      console.log("customerssitemss", documentName);
      if (nameCount[documentName]) {
        uniqueDocumentName = `${documentName} (${nameCount[documentName]})`;
        nameCount[documentName]++;
      } else {
        nameCount[documentName] = 1;
      }

      zip.file(`${uniqueDocumentName}.pdf`, blob);
    }

    zip.generateAsync({ type: "blob" }).then((content) => {
      const url = URL.createObjectURL(content);
      const link = document.createElement("a");
      link.href = url;
      link.download = "documents.zip";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      setLoading(false);
    });
  };

  console.log("selectedItems", selectedItems);

  const savePayload = (data) => {
    setResponse(data);
    if (selectedItems.length > 0) {
      setSelectedItems([]);
      setCheckedItems({});
      setAllChecked(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        overflow: "scroll",
        height: "100%",
        overflow: "scroll",
      }}
    >
      {documentsLoading || !response ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 25,
            width: "100%",
            height: "100%",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            display: "felx",
            flexDirection: "column",
            p: 1,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
            <FormControl sx={{ m: 1 }} size="small">
              <InputLabel id="pull-date-label" style={{ fontSize: "14px" }}>
                Pull Date
              </InputLabel>
              <Select
                labelId="pull-date-label"
                label="Pull Date"
                value={response?.created_at}
                style={{ fontSize: "14px", width: "200px" }}
              >
                {documentsList.map((data, index) => (
                  <MenuItem
                    key={index}
                    value={data.created_at}
                    onClick={() => savePayload(data)}
                  >
                    {formatDate(data.created_at)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "start",
              alignItems: "center",
            }}
          >
            <Checkbox
              onChange={() => handlePrintAllChange()}
              checked={allChecked}
            />

            <MenuItem>
              <Typography>Print All</Typography>
            </MenuItem>
          </Box>

          {/* {documentsList.map((item, index) => ( */}

          {response?.documents?.length > 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "start",
              }}
            >
              {response.documents.map((document, index) => (
                <>
                  {document.document_url ? (
                    <>
                      {user?.payload === "1" || user.payload === 1 ? (
                        <>
                          {document?.document_name ===
                            "INSURANCE LOAD SHEET" && (
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "start",
                                alignItems: "center",
                              }}
                              key={index}
                            >
                              <Checkbox
                                onChange={() =>
                                  handleIndividualChange(document)
                                }
                                checked={
                                  checkedItems[document.document_url] || false
                                }
                              />
                              <MenuItem
                                onClick={() => {
                                  dialog({
                                    open: true,
                                    bodyType: TYPE.DOCUMENT,
                                    maxWidth: "lg",
                                    title: document.document_name,
                                    body: (
                                      <DocumentDialog
                                        url={document.document_url}
                                        customer={customer}
                                        insuranceList={response}
                                      />
                                    ),
                                  });
                                }}
                              >
                                <Typography>
                                  {document.document_name}
                                </Typography>
                              </MenuItem>
                            </Box>
                          )}
                        </>
                      ) : (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "start",
                            alignItems: "center",
                          }}
                          key={index}
                        >
                          <Checkbox
                            onChange={() => handleIndividualChange(document)}
                            checked={
                              checkedItems[document.document_url] || false
                            }
                          />
                          <MenuItem
                            onClick={() => {
                              dialog({
                                open: true,
                                bodyType: TYPE.DOCUMENT,
                                maxWidth: "lg",
                                title: document.document_name,
                                body: (
                                  <DocumentDialog
                                    url={document.document_url}
                                    customer={customer}
                                    insuranceList={response}
                                  />
                                ),
                              });
                            }}
                          >
                            <Typography>{document.document_name}</Typography>
                          </MenuItem>
                        </Box>
                      )}
                    </>
                  ) : (
                    // Display message when document_url is null
                    <Typography key={index} sx={{ color: "red", p: 1 }}>
                      {document.document_name}
                    </Typography>
                  )}
                </>
              ))}
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                p: 1,
              }}
            >
              documents are loading. please try later.
            </Box>
          )}

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <AppButton
              buttonText={loading ? <CircularProgress size={24} /> : "Download"}
              sx={{ width: "50%", alignSelf: "center" }}
              clickHandler={handlePrint}
              disabled={loading || selectedItems.length <= 0}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default HocPopup(DocumentsDialog);
